var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 40,
    viewBox: "0 0 70 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 39,
    rx: 5.5,
    fill: "#1B1B1C",
    stroke: "#2B2B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 20V17.75C42.5 14 41 12.5 37.25 12.5H32.75C29 12.5 27.5 14 27.5 17.75V22.25C27.5 26 29 27.5 32.75 27.5H35",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7202 24.38L40.4978 24.7925C40.1603 24.905 39.8902 25.1675 39.7777 25.5125L39.3652 26.735C39.0127 27.7925 37.5277 27.77 37.1977 26.7125L35.8103 22.25C35.5403 21.365 36.3577 20.54 37.2352 20.8175L41.7053 22.205C42.7553 22.535 42.7702 24.0275 41.7202 24.38Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.20795bf1d5759ed94e6be545a74d7b6e.svg";
export { ForwardRef as ReactComponent };